module.exports = __webpack_public_path__ + "static/media/logo.bc84a20c.png";